/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actiontypes from './actiontypes';

const initialState = {};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actiontypes.AR_SUMMARY_QTR_ALL_TABLE:
      return { ...state, ar_smry_qtr_all_tbl: action.payload };
    case actiontypes.AR_SUMMARY_UNALLOCATED_QTR_TABLE:
      return {
        ...state,
        ar_smry_qtr_unallocated: action.getUnallocatedBlnQtrList,
      };
    case actiontypes.AR_SUMMARY_ALL_QTR_TABLE:
      return { ...state, ar_smry_all_qtr: action.getAllAccRecQtrList };
    case actiontypes.AR_SMRY_FOR_QTR_SINGLE:
      return { ...state, ar_smry_single_qtr_main: action.payload };
    case actiontypes.AR_SUMMARY_ALL_QTR_VALUE:
      return { ...state, getAllQuarterValue: action.getAllQuarterValue };
    case actiontypes.ACC_REBATE_LIST:
      return { ...state, rebate_list_code: action.payload };
    case actiontypes.ALL_FLD_DATA:
      return { ...state, qtr_field_value: action.payload };
    case actiontypes.ACC_REBATE_PGM_NAME:
      return { ...state, rebate_pgm_name: action.payload };
    case actiontypes.AR_SUMMERY_QTR_ALL_FIELD_CLEAR_REDUX:
      return action.payload ? action.payload : {};
    default:
      return state;
  }
};

export default reducer;
